// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__GHX69","text":"ErrorBoundary_text__a1XzE"};